import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FAFAFA",
      "stroke-linecap": "round",
      "stroke-width": ".75",
      d: "M8.5 1.5v9M6 1.5v9M3.5 1.5v9"
    }, null, -1)
  ]))]))
}
export default { render: render }